import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const PORTFOLIO_WORKFLOWS_FEATURE_FLAG = 'portfolio-workflows';

export const portfolioPlugin = createPlugin({
  id: 'portfolio',
  routes: {
    root: rootRouteRef,
  },
  featureFlags: [
    {
      name: PORTFOLIO_WORKFLOWS_FEATURE_FLAG,
      description:
        'Show the Workflows view and the Workflows / AI solutions switch on the AI Portfolio page.',
    },
  ],
});

export const PortfolioPage = portfolioPlugin.provide(
  createRoutableExtension({
    name: 'PortfolioPage',
    component: () =>
      import('./components/PortfolioPage').then(m => m.PortfolioPage),
    mountPoint: rootRouteRef,
  }),
);

export const PortfolioEngineDetailsPage = portfolioPlugin.provide(
  createRoutableExtension({
    name: 'PortfolioEngineDetailsPage',
    component: () =>
      import('./components/EngineDetailsPage/EngineDetailsPageWrapper').then(
        m => m.EngineDetailsPageWrapper,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const PortfolioAdminPage = portfolioPlugin.provide(
  createRoutableExtension({
    name: 'PortfolioAdminPage',
    component: () =>
      import('./components/EngineAdminPage').then(m => m.EngineAdminPage),
    mountPoint: rootRouteRef,
  }),
);
